import { MessageProcessor } from '../websocketProcessorTypes'
import store from '../../redux/store'
import {
  addMessage,
  setIsLoadingMessages,
} from '../../redux/slices/adjudicationMessageSlice'
import { commonProcessors } from './commonProcessors'

export const adjudicationProcessors: MessageProcessor[] = [
  {
    type: 'populate_messages',
    handler: (data) => {
      if (Array.isArray(data.messages)) {
        data.messages.forEach((msg: any) => {
          store.dispatch(addMessage(msg))
        })
        store.dispatch(setIsLoadingMessages(false))
      }
    },
  },
  {
    type: 'message',
    handler: (data) => {
      if (data.message) {
        store.dispatch(
          addMessage({
            id: data.id ?? data.message_id,
            message: data.message,
            user: data.user,
            created_at: data.created_at,
            streaming: data.streaming,
            final: data.final,
            senderName: data.senderName,
            senderType: data.senderType,
            llm_provider: data.llm_provider,
            llm_model_name: data.llm_model_name,
          })
        )
      }
    },
  },
  ...commonProcessors,
]
